module.exports = __webpack_public_path__ + "static/img/mgv.60001aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mgv.png
// module id = Vs8l
// module chunks = 1